<div class="template-area mt-4">
  <div class="row">
    <div class="col-7">
      <h3 class="h5 mb-3 text-dark">{{ 'waTemplate.webhookMessage.editVariables' | translate }}</h3>
      <form [formGroup]="formGroup">
        <!-- HEADERS -->
        <div formArrayName="headers">
          @for (header of headers.controls; track header; let index = $index) {
          <div class="mb-3" [formGroupName]="index">
            <label class="form-label mb-2">{{ 'waTemplate.webhookMessage.headerVariable' | translate }}</label>
            <div class="d-flex gap-2 align-items-center">
              <input class="form-control" type="text" formControlName="value" [placeholder]="'waTemplate.webhookMessage.namePlaceholder' | translate" />
              <!-- <div class="btn-group">
                  <button type="button" class="btn btn-outline-dark dropdown-toggle" data-bs-toggle="dropdown">
                    Variáveis
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    @for (request of webhookRequestKeys; track $index) {
                      <li>
                        <button class="dropdown-item"
                          (click)="!webhookIntegrations.actived && updateValueForm(request, index, 'header')">
                          {{ request }}
                        </button>
                      </li>
                    }
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <button class="dropdown-item"
                        (click)="!webhookIntegrations.actived && updateValueFormOperatorName(index, 'header')">
                        Nome atendente
                      </button>
                    </li>
                  </ul>
                </div> -->
            </div>
          </div>
          }
        </div>


        <!-- BODYS -->
        <div formArrayName="bodys">
          @for (body of bodys.controls; track body; let index = $index) {
          <div class="mb-3" [formGroupName]="index">
            <label class="fw-semibold mb-2">{{ 'waTemplate.webhookMessage.variable' | translate }} {{ index + 1 }}</label>
            <div class="d-flex gap-2 align-items-center">
              <input class="form-control" type="text" formControlName="value" [placeholder]="'waTemplate.webhookMessage.namePlaceholder' | translate" />
              <!-- <div class="btn-group">
                  <button type="button" class="btn btn-outline-dark dropdown-toggle" data-bs-toggle="dropdown">
                    Variáveis
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    @for (request of webhookRequestKeys; track $index) {
                      <li>
                        <button class="dropdown-item"
                          (click)="!webhookIntegrations.actived && updateValueForm(request, index, 'body')">
                          {{ request }}
                        </button>
                      </li>
                    }
                    <li><hr class="dropdown-divider" /></li>
                    <li>
                      <button class="dropdown-item"
                        (click)="!webhookIntegrations.actived && updateValueFormOperatorName(index, 'body')">
                        Nome atendente
                      </button>
                    </li>
                  </ul>
                </div> -->
            </div>
          </div>
          }
        </div>

        <!-- BUTTONS -->
        <div formArrayName="buttons">
          @for (button of buttons.controls; track button; let index = $index) {
          <div class="mb-3" [formGroupName]="index">
            <label class="fw-semibold mb-2">{{ 'waTemplate.webhookMessage.variable' | translate }} {{ index + 1 }}</label>
            <div class="d-flex gap-2 align-items-center">
              <input class="form-control" type="text" formControlName="value" [placeholder]="'waTemplate.webhookMessage.namePlaceholder' | translate" />
            </div>
          </div>
          }
        </div>
        
      </form>
    </div>

    <div class="col-5 custom-template">
      <h3 class="h5 mb-4 text-dark">{{ 'waTemplate.webhookMessage.templatePreview' | translate }}</h3>
      <div class="template-area__preview position-relative d-flex justify-content-center">
        <!-- mockup -->
        <img src="../../../../../assets/images/v2/iphone_mockup.png" [alt]="'waTemplate.webhookMessage.previewAlt' | translate" class="img-fluid"
          style="max-width: 320px;" />

        <div class="prev-content custom-scroll-bar position-absolute top-0 start-50 translate-middle-x"
          style="width: 83%; margin-top: 10%; overflow-y: auto;">
          @if (!isMedia) {
          <div class="d-flex w-100 align-items-center mb-2">
            <b>{{ previewHeader }}</b>
          </div>
          } @else {
          <div class="upload-area text-center border-dashed">
            @if (loadingSpinnerTemplate$ | async) {
            <loading-component class="loading" diameter="20" />
            } @else {
            @if (!headerValue) {
            <label for="dropzone-file" class="d-block cursor-pointer w-100">
              <div class="placeholder-content">
                <i class="mdi mdi-cloud-upload-outline upload-icon"></i>
                <p class="text-primary mb-1 small">{{ 'waTemplate.webhookMessage.clickToUpload' | translate }} <br />
                  {{ 'waTemplate.webhookMessage.orDragAndDrop' | translate }}</p>
                <p class="text-muted small">
                  @if(isHeaderDocument()) { PDF }
                  @else if(isHeaderVideo()) { MP4 }
                  @else if(isHeaderImage()) { PNG, JPG ou JPEG }
                </p>
              </div>
            </label>
            }

            @if (headerValue && typeFile === 'image') {
            <label for="dropzone-file">
              <img [src]="headerValue" alt="image" class="img-fluid rounded" />
            </label>
            }

            @if (headerValue && typeFile !== 'image' && typeFile !== 'text') {
            <a [href]="headerValue" target="_blank" class="text-decoration-none text-dark">
              <span class="d-flex gap-3 align-items-center">
                <img [src]="getIconForContentType()" alt="" width="32" />
                <strong>{{ 'waTemplate.webhookMessage.clickToOpen' | translate }} {{ typeFile === 'image'? 'sua' : 'seu'}} {{ typeFile }}.</strong>
              </span>
            </a>
            }

            <input id="dropzone-file" type="file" class="d-none" [accept]="acceptFiles()"
              (change)="webhookIntegrations.actived ? '' : onSelectImagem($event)" />
            }
          </div>
          }

          <div class="mt-2" style="word-wrap: break-word;">
            {{ previewText }}
          </div>

          @if (buttonsComponent?.buttons && buttonsComponent?.buttons.length > 0) {
          <div class="text-sm d-flex flex-column align-items-center w-100 my-3">
            @for (item of buttonsComponent?.buttons; track $index) {
            <div
              class="d-flex align-items-center justify-content-center w-100 border-top py-2 fs-5 fw-medium text-primary">
              <i class="mdi mdi-arrow-left-top me-2 fs-4"></i>
              <span>{{ item.text }}</span>
            </div>
            }
          </div>
          }

          @if (previewFooter) {
          <div class="wa-footer text-muted small mt-2">
            {{ previewFooter }}
          </div>
          }

          <div class="d-flex justify-content-end w-100">
            <span class="time small text-muted mt-1">12:45 PM</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>